import { useCallback, useContext, useMemo } from "react";
import StreamsContext from "contexts/StreamsContext";
import { useInputs } from "hooks/useInputs";
import useNodeSummaries from "hooks/useNodeSummaries";
import { getPriorityName } from "logic/alerts/EventDefinitionPriorityEnum";
const formatNode = (node) => `${node.short_node_id} / ${node.hostname}`;
const useStreamsKeyMapper = () => {
  const streams = useContext(StreamsContext);
  const streamsMap = useMemo(() => Object.fromEntries((streams != null ? streams : []).map((stream) => [stream.id, stream])), [streams]);
  return useCallback((key) => {
    var _a, _b;
    return (_b = (_a = streamsMap[key]) == null ? void 0 : _a.title) != null ? _b : key;
  }, [streamsMap]);
};
const useInputKeyMapper = () => {
  const inputs = useInputs();
  return useCallback((key) => {
    var _a, _b;
    return (_b = (_a = inputs == null ? void 0 : inputs[key]) == null ? void 0 : _a.title) != null ? _b : key;
  }, [inputs]);
};
const useNodeKeyMapper = () => {
  const nodes = useNodeSummaries();
  return useCallback((key) => (nodes == null ? void 0 : nodes[key]) ? formatNode(nodes[key]) : key, [nodes]);
};
const CoreKeyMappers = [
  { type: "streams", useKeyMapper: useStreamsKeyMapper },
  { type: "input", useKeyMapper: useInputKeyMapper },
  { type: "node", useKeyMapper: useNodeKeyMapper },
  { type: "priority", useKeyMapper: () => getPriorityName }
];
export default CoreKeyMappers;
